import React from 'react';
import { useRouter } from 'next/router';
import has from 'lodash/has';
import PropTypes from 'prop-types';
import BlogHero from './BlogHero';
import BlogTile from './BlogTile';
import BlogCategoryList from './BlogCategoryList';
import Paginate from '../BlogPaginate/PaginateComponent';
import { BlogComponentStyles } from './BlogListComponentStyles';

const BlogListComponent = ({ posts, totalPage, currentPage, categories }) => {
  const router = useRouter();

  const hasSearchKey = has(router.query, 's');
  const hasResult = posts.length > 0;

  return (
    <>
      <BlogHero />
      <BlogComponentStyles>
        <div className="container">
          {hasSearchKey ? (
            <div className="search-title">
              <h2>Search Results</h2>
            </div>
          ) : (
            <BlogCategoryList categories={categories} />
          )}
          <div className="posts">
            {posts.map(p => (
              <BlogTile key={p.id} data={p} />
            ))}
            {!hasResult ? (
              <h2 className="no-result">Sorry, nothing to display.</h2>
            ) : null}
          </div>
        </div>
        {hasResult ? (
          <Paginate pageCount={Number(totalPage)} current={currentPage} />
        ) : null}
      </BlogComponentStyles>
    </>
  );
};

BlogListComponent.propTypes = {
  posts: PropTypes.array,
  totalPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

BlogListComponent.defaultProps = {
  posts: [],
  totalPage: 0,
};

export default BlogListComponent;
